import { Component, Input, OnChanges, ViewChild, ElementRef, ChangeDetectionStrategy, NgZone, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router'
import { DomSanitizer } from '@angular/platform-browser'

@Component({
    moduleId: module.id,
    selector: 'cm-avatar',
    templateUrl: 'avatar.component.html',
    styleUrls: ['avatar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent implements OnChanges {

    @Input() uid: string
    @Input() image: string

    @ViewChild('avatarHost')
    avatarHost: ElementRef

    loaded = false

    private readonly malePictureUrl = 'https://scontent.xx.fbcdn.net/v/t1.0-1/s200x200/10354686_10150004552801856_220367501106153455_n.jpg'
    private readonly femalePictureUrl = 'https://scontent.xx.fbcdn.net/v/t1.0-1/s200x200/1379841_10150004552801901_469209496895221757_n.jpg'

    constructor(private sanitizer: DomSanitizer,
      private router: Router,
      private cd: ChangeDetectorRef) { }

    ngOnChanges() {
      // Load image and listen load event to apply loaded image as background
      if (this.image) {
        const imageToLoad = new Image()
        imageToLoad.onload = () => {
          this.loaded = true
          this.avatarHost.nativeElement.style.backgroundImage = `url(${imageToLoad.src})`
          imageToLoad.remove()
          this.cd.markForCheck()
        }

        imageToLoad.src = this.image
      }
    }

    getImageUrl() {
        let url: string

        if (this.image) {
          if (this.image.includes(this.malePictureUrl)) {
            url = '../../../assets/img/users/default_male.png'
          } else if (this.image.includes(this.femalePictureUrl)) {
            url = '../../../assets/img/users/default_female.png'
          } else {
            url = this.image
          }

          return this.sanitizer.bypassSecurityTrustStyle(`url(${url})`)
        } else {
            return ''
        }
    }

    showProfile() {
        if (this.uid) {
            return this.router.navigate(['/profile', this.uid])
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/avatar/avatar.component.ts